module.exports = __webpack_public_path__ + "img/404.395c9610.svg";